// extracted by mini-css-extract-plugin
export var equalColumn = "_fo-0";